<template>
  <div>
    <!-- Preference Card -->
    <div class="preference-card">
      <div class="preference-content">
        <h3 class="preference-card-title">Customize Your Travel Experience!</h3>
        <p class="preference-card-description">
          Fully customize your travel plans to match your unique style and
          preferences.
        </p>

        <div class="preference-stats">
          <div class="stat-item">
            <div class="stat-value">100%</div>
            <p class="stat-description">
              Completely personalized travel plans tailored just for you
            </p>
          </div>
          <div class="stat-item">
            <div class="stat-value">x10</div>
            <p class="stat-description">
              Create itineraries 10x faster than with other tools
            </p>
          </div>
        </div>

        <button class="start-planning-btn">Start Planning Now</button>
      </div>
      <div class="preference-video-container">
        <video class="preference-video" autoplay muted loop playsinline>
          <source src="/assets/videos/preferences.mp4" type="video/mp4" />
        </video>
      </div>
    </div>

    <!-- Date and Budget Cards -->
    <div class="cards-container">
      <div class="date-card">
        <div class="date-content">
          <h3 class="date-card-title">Plan Your Perfect Date</h3>
          <p class="date-card-description">
            Choose your travel dates and let us help you create the perfect
            itinerary for your journey.
          </p>
        </div>
        <div class="date-video-container">
          <video class="date-video" autoplay muted loop playsinline>
            <source src="/assets/videos/dates.mp4" type="video/mp4" />
          </video>
        </div>
      </div>

      <div class="budget-card">
        <div class="budget-content">
          <h3 class="budget-card-title">Travel budget Friends</h3>
          <p class="budget-card-description">
            Share your journey with friends and family to make memories
            together.
          </p>
        </div>
        <div class="budget-video-container">
          <video class="budget-video" autoplay muted loop playsinline>
            <source src="/assets/videos/budget.mp4" type="video/mp4" />
          </video>
        </div>
      </div>
    </div>

    <!-- TravelWith Card -->
    <div class="travelwith-card">
      <div class="travelwith-video-container">
        <video class="travelwith-video" autoplay muted loop playsinline>
          <source src="/assets/videos/with.mp4" type="video/mp4" />
        </video>
      </div>
      <div class="travelwith-content">
        <h3 class="travelwith-card-title">Travel With Friends!</h3>
        <p class="travelwith-card-description">
          Share your journey with friends and family to make memories together.
        </p>

        <div class="travelwith-stats">
          <div class="stat-item">
            <div class="stat-value">50+</div>
            <p class="stat-description">
              Group-friendly destinations and activities to choose from
            </p>
          </div>
          <div class="stat-item">
            <div class="stat-value">24/7</div>
            <p class="stat-description">
              Real-time collaboration with your travel companions
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TravelCards",
};
</script>
